import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";

export interface ScreenOrder {
    isUpdate: boolean;
}


const initialState: ScreenOrder = {
    isUpdate: false,
};

const orderSlice = createSlice({
  name: "screenOrder",
  initialState,
  reducers: {
    setScreenOrderUpdate: (state, action: PayloadAction<boolean>) => {
      state.isUpdate = action.payload;
    },
  },
});

export const { setScreenOrderUpdate } = orderSlice.actions;
export const selectScreenOrderState = (state: RootState) => state.screenOrder.isUpdate;
export default orderSlice.reducer;
